import { render, staticRenderFns } from "./site-warnings-list.component.vue?vue&type=template&id=2837123f"
import script from "./site-warnings-list.component.ts?vue&type=script&lang=ts&external"
export * from "./site-warnings-list.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports